import React from 'react'
import CopyToClipboard from '@cloudscape-design/components-themed/copy-to-clipboard'

// https://cloudscape.design/components/copy-to-clipboard
export function RadCopyToClipboard ({ ...rest }) {
  return (
    <CopyToClipboard className='copy-to-clipboard' {...rest} copyButtonText='Copy Link' />
  )
}
